"use strict";

var _slicedToArray = require("/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TikTokEmbed = void 0;

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var react_sub_unsub_1 = require("react-sub-unsub");

var useFrame_1 = require("../hooks/useFrame");

var PlaceholderEmbed_1 = require("../placeholder/PlaceholderEmbed");

var uuid_1 = require("../uuid");

var EmbedStyle_1 = require("./EmbedStyle");

var embedJsScriptSrc = 'https://www.tiktok.com/embed.js';
var minPlaceholderWidth = 325;
var maxPlaceholderWidth = 480;
var defaultPlaceholderHeight = 550;
var borderRadius = 8; // Embed Stages

var PROCESS_EMBED_STAGE = 'process-embed';
var CONFIRM_EMBED_SUCCESS_STAGE = 'confirm-embed-success';
var RETRYING_STAGE = 'retrying';
var EMBED_SUCCESS_STAGE = 'embed-success';

var TikTokEmbed = function TikTokEmbed(_a) {
  var _b, _c;

  var url = _a.url,
      width = _a.width,
      height = _a.height,
      _a$linkText = _a.linkText,
      linkText = _a$linkText === void 0 ? 'View post on TikTok' : _a$linkText,
      placeholderImageUrl = _a.placeholderImageUrl,
      placeholderSpinner = _a.placeholderSpinner,
      _a$placeholderSpinner = _a.placeholderSpinnerDisabled,
      placeholderSpinnerDisabled = _a$placeholderSpinner === void 0 ? false : _a$placeholderSpinner,
      placeholderProps = _a.placeholderProps,
      embedPlaceholder = _a.embedPlaceholder,
      _a$placeholderDisable = _a.placeholderDisabled,
      placeholderDisabled = _a$placeholderDisable === void 0 ? false : _a$placeholderDisable,
      _a$scriptLoadDisabled = _a.scriptLoadDisabled,
      scriptLoadDisabled = _a$scriptLoadDisabled === void 0 ? false : _a$scriptLoadDisabled,
      _a$retryDelay = _a.retryDelay,
      retryDelay = _a$retryDelay === void 0 ? 5000 : _a$retryDelay,
      _a$retryDisabled = _a.retryDisabled,
      retryDisabled = _a$retryDisabled === void 0 ? false : _a$retryDisabled,
      _a$frame = _a.frame,
      frame = _a$frame === void 0 ? undefined : _a$frame,
      _a$debug = _a.debug,
      debug = _a$debug === void 0 ? false : _a$debug,
      divProps = __rest(_a, ["url", "width", "height", "linkText", "placeholderImageUrl", "placeholderSpinner", "placeholderSpinnerDisabled", "placeholderProps", "embedPlaceholder", "placeholderDisabled", "scriptLoadDisabled", "retryDelay", "retryDisabled", "frame", "debug"]);

  var _react_1$default$useS = react_1.default.useState(PROCESS_EMBED_STAGE),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      stage = _react_1$default$useS2[0],
      setStage = _react_1$default$useS2[1];

  var uuidRef = react_1.default.useRef((0, uuid_1.generateUUID)());

  var _react_1$default$useS3 = react_1.default.useState(Date.now()),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      processTime = _react_1$default$useS4[0],
      setProcessTime = _react_1$default$useS4[1];

  var embedContainerKey = react_1.default.useMemo(function () {
    return "".concat(uuidRef.current, "-").concat(processTime);
  }, [processTime]);
  var frm = (0, useFrame_1.useFrame)(frame); // Debug Output

  react_1.default.useEffect(function () {
    debug && console.log("[".concat(new Date().toISOString(), "]: ").concat(stage));
  }, [debug, stage]); // === === === === === === === === === === === === === === === === === === ===
  // Embed Stages
  // === === === === === === === === === === === === === === === === === === ===
  // Process Embed Stage

  react_1.default.useEffect(function () {
    if (stage === PROCESS_EMBED_STAGE) {
      if (frm.document && !scriptLoadDisabled) {
        var scriptId = "tiktok-embed-script";
        var prevScript = frm.document.getElementById(scriptId);

        if (prevScript) {
          prevScript.remove();
        }

        var scriptElement = frm.document.createElement('script');
        scriptElement.setAttribute('src', "".concat(embedJsScriptSrc, "?t=").concat(Date.now()));
        scriptElement.setAttribute('id', scriptId);
        frm.document.head.appendChild(scriptElement);
        setStage(CONFIRM_EMBED_SUCCESS_STAGE);
      }
    }
  }, [scriptLoadDisabled, stage, frm.document]); // Confirm Embed Success Stage

  react_1.default.useEffect(function () {
    var subs = new react_sub_unsub_1.Subs();

    if (stage === CONFIRM_EMBED_SUCCESS_STAGE) {
      subs.setInterval(function () {
        if (frm.document) {
          var preEmbedElement = frm.document.getElementById(uuidRef.current);

          if (!preEmbedElement) {
            setStage(EMBED_SUCCESS_STAGE);
          }
        }
      }, 1);

      if (!retryDisabled) {
        subs.setTimeout(function () {
          setStage(RETRYING_STAGE);
        }, retryDelay);
      }
    }

    return subs.createCleanup();
  }, [retryDelay, retryDisabled, stage, frm.document]); // Retrying Stage

  react_1.default.useEffect(function () {
    if (stage === RETRYING_STAGE) {
      // This forces the embed container to remount
      setProcessTime(Date.now());
      setStage(PROCESS_EMBED_STAGE);
    }
  }, [stage]); // END Embed Stages
  // === === === === === === === === === === === === === === === === === === ===
  // Format: https://www.tiktok.com/@epicgardening/video/7055411162212633903?is_copy_url=1&is_from_webapp=v1

  var embedId = url.replace(/[?].*$/, '').replace(/^.+\//, ''); // === Placeholder ===

  var placeholderStyle = {
    minWidth: minPlaceholderWidth,
    maxWidth: maxPlaceholderWidth,
    width: typeof width !== 'undefined' ? width : '100%',
    height: typeof height !== 'undefined' ? height : typeof ((_b = divProps.style) === null || _b === void 0 ? void 0 : _b.height) !== 'undefined' || typeof ((_c = divProps.style) === null || _c === void 0 ? void 0 : _c.maxHeight) !== 'undefined' ? '100%' : defaultPlaceholderHeight,
    border: 'solid 1px rgba(22,24,35,0.12)',
    borderRadius: borderRadius
  };
  var placeholder = embedPlaceholder !== null && embedPlaceholder !== void 0 ? embedPlaceholder : react_1.default.createElement(PlaceholderEmbed_1.PlaceholderEmbed, Object.assign({
    url: url,
    imageUrl: placeholderImageUrl,
    linkText: linkText,
    spinner: placeholderSpinner,
    spinnerDisabled: placeholderSpinnerDisabled
  }, placeholderProps, {
    style: Object.assign(Object.assign({}, placeholderStyle), placeholderProps === null || placeholderProps === void 0 ? void 0 : placeholderProps.style)
  })); // === END Placeholder ===

  return react_1.default.createElement("div", Object.assign({}, divProps, {
    className: (0, classnames_1.default)('rsme-embed rsme-tiktok-embed', divProps.className),
    style: Object.assign({
      overflow: 'hidden',
      width: width !== null && width !== void 0 ? width : undefined,
      height: height !== null && height !== void 0 ? height : undefined,
      borderRadius: borderRadius
    }, divProps.style)
  }), react_1.default.createElement(EmbedStyle_1.EmbedStyle, null), react_1.default.createElement("div", {
    className: "tiktok-embed-container"
  }, react_1.default.createElement("blockquote", {
    key: embedContainerKey,
    className: "tiktok-embed",
    cite: url,
    "data-video-id": embedId
  }, !placeholderDisabled ? react_1.default.createElement("div", {
    id: uuidRef.current,
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, placeholder) : react_1.default.createElement("div", {
    id: uuidRef.current,
    style: {
      display: 'none'
    }
  }, "\xA0"))));
};

exports.TikTokEmbed = TikTokEmbed;